import { AlunoCurso } from "../models";
import dias from "../services/diasApi";
import { turnosHorarios } from "./turnos-horarios";

export function alunoCursoTurnosHorarios(alunoCurso: Partial<AlunoCurso>) {
  return turnosHorarios(alunoCurso?.professor_temp, alunoCurso?.dias_semana_temp);
}
